import { useApi } from '@axiom/ui';
import type {
  AfcSubmissionsItem,
  AfcSubmission,
  AfcSubmissionCandidate,
} from '@axiom/validation';

import { InstantMatchesApi } from '../../api/instant-matches-api';
import { SubmissionApi } from '../../api/submission-api';

export const useEngagementCarouselSubmissionData = (
  submissions: AfcSubmissionsItem[]
) => {
  const allSubmissionDetails = useApi(
    ...submissions.map(({ submissionId }) =>
      SubmissionApi.readSubmissionDetails(submissionId)
    )
  ).reduce<AfcSubmission[]>((acc, crnt: { data?: AfcSubmission }) => {
    if (crnt.data) {
      acc.push(crnt.data);
    }
    return acc;
  }, []);

  const allSubmissionsData = submissions.reduce<
    Array<{
      submission: AfcSubmissionsItem;
      submissionDetails: AfcSubmission;
    }>
  >((crnt, submission, index) => {
    crnt.push({
      submission,
      submissionDetails: allSubmissionDetails[index] as AfcSubmission,
    });

    return crnt;
  }, []);

  const allInstantMatchCandidates = useApi(
    ...allSubmissionDetails.map(submission => {
      return InstantMatchesApi.readInstantMatches(submission.submissionId);
    })
  ).reduce<AfcSubmissionCandidate[][]>((acc, response) => {
    const data = response.data.matches;
    const validCandidates = data
      .filter(match => !match.passed)
      .map(cOpp => cOpp.candidate);
    acc.push(validCandidates);
    return acc;
  }, []);

  return {
    allSubmissionsData,
    allInstantMatchCandidates,
  };
};
